<template>
  <div class="w-100 bg-white">
    <Navbar />
    <block :height="73"></block>
    <div class="ga-container">
      <b-skeleton-wrapper :loading="is_load">
        <template #loading>
          <b-row class="slim-grid-row mb-3">
            <b-col cols="12" class="mb-2">
              <b-skeleton width="40%" height="56px"></b-skeleton>
              <b-skeleton width="50%" height="30px"></b-skeleton>
            </b-col>
            <b-col cols="8">
              <b-skeleton width="100%" height="400px"></b-skeleton>
            </b-col>
            <b-col cols="4">
              <b-row class="slim-grid-row">
                <b-col cols="6" class="mb-2">
                  <b-skeleton width="100%" height="192px" class="mb-0"></b-skeleton>
                </b-col>
                <b-col cols="6" class="mb-2">
                  <b-skeleton width="100%" height="192px" class="mb-0"></b-skeleton>
                </b-col>
                <b-col cols="12" class="mt-2">
                  <b-skeleton width="100%" height="192px" class="mb-0"></b-skeleton>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="slim-grid-row mb-4">
            <b-col cols="2" v-for="i in 3" :key="i">
              <b-skeleton width="100%" height="40px"></b-skeleton>
            </b-col>
          </b-row>

          <div class="row mb-4">
            <div class="col-lg-8 col-md-12">
              <div class="pr-xl-5 pr-0">
                <div class="radius-12 bg-white box-shadow-light-aff border-semi-grey mb-3" v-for="i in 3">
                  <div class="row no-gutters">
                    <div class="col-md-3 col-12">
                      <b-skeleton-img no-aspect width="100%" height="200px" card-img="left"></b-skeleton-img>
                    </div>
                    <div class="col-md-9 col-12">
                      <div class="row no-gutters">
                        <div class="col-sm-8 col-12 border-r-semi-grey">
                          <div class="p-3 card-product-height position-relative">
                            <b-skeleton width="50%" height="28px" class="mb-2"></b-skeleton>
                            <b-skeleton width="100%" height="21px"></b-skeleton>
                            <b-skeleton width="60%" height="21px"></b-skeleton>
                            <div class="w-100 position-absolute px-3" style="bottom: 16px;left: 0px;">
                              <div class="row">
                                <div class="col-8 align-self-end">
                                  <b-skeleton width="30%" height="21px"></b-skeleton>
                                  <b-skeleton width="90%" height="21px"></b-skeleton>
                                </div>
                                <div class="col-4 align-self-end text-right">
                                  <b-skeleton width="100%" height="21px"></b-skeleton>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 col-12">
                          <div class="pr-3 py-3 w-100 pl-sm-0 pl-3" :class="window_width >= 576 ? 'card-product-height':''">
                            <div class="row align-items-center">
                              <div class="col-sm-12 col-7">
                                <div class="w-100" :class="window_width >= 576 ? 'mb-3' : ''">
                                  <b-skeleton width="80px" height="18px" class="ml-sm-auto ml-0"></b-skeleton>
                                  <b-skeleton width="80%" height="30px" class="ml-sm-auto ml-0"></b-skeleton>
                                  <b-skeleton width="60%" height="18px" class="ml-sm-auto ml-0"></b-skeleton>
                                </div>
                              </div>
                              <div v-if="window_width < 576" class="col-5 text-right">
                                <b-skeleton width="80%" height="50px"></b-skeleton>
                              </div>
                            </div>
                            <div v-if="window_width >= 576" class="w-100 position-absolute px-3 text-right" style="bottom: 16px;left: 0px;">
                              <b-skeleton width="80%" height="50px" class="ml-sm-auto ml-0"></b-skeleton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12" v-if="window_width >= 992">
              <div class="radius-12 bg-white box-shadow-light-aff border-semi-grey">
                <div class="general-booking-summary">
                  <div class="p-4">
                    <b-skeleton width="40%" height="24px"></b-skeleton>
                    <b-skeleton width="70%" height="30px"></b-skeleton>
                  </div>
                  <div class="w-100 px-4 pb-4 pt-4 border-b-semi-grey">
                    <div class="row">
                      <div class="col-4">
                        <b-skeleton width="60%" height="30px"></b-skeleton>
                      </div>
                      <div class="col-8">
                        <b-skeleton width="60%" height="30px" class="ml-auto"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="w-100 pt-4" v-if="error != ''">
          <ErrorMessage :message="error"></ErrorMessage>
        </div>
        <template v-else>
          <!-- TAGLINE & SUBTAGLINE  -->
          <div class="w-100 mb-3">
            <p class="mb-0" :class="window_width >= 992 ? 'heading-4-1' : 'heading-5-2'">{{ general_data.tagline }}</p>
            <p class="mb-0" :class="window_width >= 992 ? 'body-1' : 'body-2'">{{ general_data.sub_tagline }}</p>
          </div>
          
          <!-- SLIDER -->
          <div class="w-100 mb-4 position-relative">
            <HomeSlider :image_list="general_data.slider_list"></HomeSlider>
          </div>

          <!-- CATEGORY -->
          <div class="w-100 mb-3">
            <div class="w-100 no-ws pb-3" style="overflow-x: auto;white-space: nowrap;">
              <template v-for="cat in category.list">
                <div 
                  v-if="cat.show"
                  @click="selectCategory(cat)"
                  class="spa-category-item" 
                  :class="cat.id == category.selected.id?'active':''">
                  <span :class="cat.id == category.selected.id?'body-2-4 text-white':'body-2'">{{ cat.name }}</span>
                </div>
              </template>
            </div>
          </div>

          <!-- MAIN CONTENT -->
          <div class="w-100">
            <div class="row">
              <div class="col-lg-8 col-md-12">
                <div class="pr-xl-5 pr-0">
                  <div class="w-100 mb-4" v-for="product in  product_display">
                    <Product :data="product" :general_data="general_data"></Product>
                  </div>
                </div>
              </div>

              <!-- DESKTOP -->
              <div class="col-lg-4 col-md-12" v-if="window_width >= 992">
                <div class="general-booking-summary">
                  <div class="radius-12 bg-white box-shadow-light-aff border-semi-grey overflow-hidden">
                    <div class="p-4 bg-top-black">
                      <p class="mb-0 body-2-2 font-semibold text-16 text-white">Booking Summary</p>
                      <p class="mb-0 body-2-2 font-bold text-20 text-white">{{ getMerchant.name }}</p>
                    </div>
                    <div class="px-4 pt-4 border-b-semi-grey" v-if="getActivityTrxProducts.length > 0">
                      <CartTimer v-if="window_width >= 992 && $isNotEmpty(getActivityTrxExpiredAt)" />
                      <div class="row no-gutters mb-4" v-for="(product_cart,product_cart_i) in getActivityTrxProducts">
                        <div class="col-8">
                          <p class="mb-2 body-1-4 ">{{ product_cart.original_data.name }}</p>
                          <div class="w-100 no-ws mb-1">
                            <div class="d-inline-block align-middle mr-2">
                              <svg class="lh-1" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M2.45504 16.9507H13.1352C14.7693 16.9507 15.5825 16.1376 15.5825 14.5269V4.98045C15.5825 3.36982 14.7693 2.55669 13.1352 2.55669H2.45504C0.820954 2.55669 0 3.362 0 4.98045V14.5269C0 16.1454 0.820954 16.9507 2.45504 16.9507ZM2.33776 15.6919C1.64191 15.6919 1.2588 15.3245 1.2588 14.5973V7.22437C1.2588 6.50508 1.64191 6.12979 2.33776 6.12979H13.2369C13.9327 6.12979 14.3237 6.50508 14.3237 7.22437V14.5973C14.3237 15.3245 13.9327 15.6919 13.2369 15.6919H2.33776Z"
                                  fill="black" fill-opacity="0.85" />
                                <path
                                  d="M6.27053 8.93664H6.7318C7.00548 8.93664 7.09148 8.85844 7.09148 8.58483V8.12354C7.09148 7.84986 7.00548 7.76385 6.7318 7.76385H6.27053C5.99688 7.76385 5.90306 7.84986 5.90306 8.12354V8.58483C5.90306 8.85844 5.99688 8.93664 6.27053 8.93664ZM8.86633 8.93664H9.32762C9.60124 8.93664 9.69504 8.85844 9.69504 8.58483V8.12354C9.69504 7.84986 9.60124 7.76385 9.32762 7.76385H8.86633C8.59265 7.76385 8.49884 7.84986 8.49884 8.12354V8.58483C8.49884 8.85844 8.59265 8.93664 8.86633 8.93664ZM11.4621 8.93664H11.9234C12.197 8.93664 12.2909 8.85844 12.2909 8.58483V8.12354C12.2909 7.84986 12.197 7.76385 11.9234 7.76385H11.4621C11.1884 7.76385 11.1024 7.84986 11.1024 8.12354V8.58483C11.1024 8.85844 11.1884 8.93664 11.4621 8.93664ZM3.67475 11.4934H4.12824C4.40971 11.4934 4.49571 11.4152 4.49571 11.1415V10.6802C4.49571 10.4066 4.40971 10.3284 4.12824 10.3284H3.67475C3.39329 10.3284 3.30728 10.4066 3.30728 10.6802V11.1415C3.30728 11.4152 3.39329 11.4934 3.67475 11.4934ZM6.27053 11.4934H6.7318C7.00548 11.4934 7.09148 11.4152 7.09148 11.1415V10.6802C7.09148 10.4066 7.00548 10.3284 6.7318 10.3284H6.27053C5.99688 10.3284 5.90306 10.4066 5.90306 10.6802V11.1415C5.90306 11.4152 5.99688 11.4934 6.27053 11.4934ZM8.86633 11.4934H9.32762C9.60124 11.4934 9.69504 11.4152 9.69504 11.1415V10.6802C9.69504 10.4066 9.60124 10.3284 9.32762 10.3284H8.86633C8.59265 10.3284 8.49884 10.4066 8.49884 10.6802V11.1415C8.49884 11.4152 8.59265 11.4934 8.86633 11.4934ZM3.67475 14.0578H4.12824C4.40971 14.0578 4.49571 13.9718 4.49571 13.6982V13.2369C4.49571 12.9632 4.40971 12.885 4.12824 12.885H3.67475C3.39329 12.885 3.30728 12.9632 3.30728 13.2369V13.6982C3.30728 13.9718 3.39329 14.0578 3.67475 14.0578ZM6.27053 14.0578H6.7318C7.00548 14.0578 7.09148 13.9718 7.09148 13.6982V13.2369C7.09148 12.9632 7.00548 12.885 6.7318 12.885H6.27053C5.99688 12.885 5.90306 12.9632 5.90306 13.2369V13.6982C5.90306 13.9718 5.99688 14.0578 6.27053 14.0578ZM8.86633 14.0578H9.32762C9.60124 14.0578 9.69504 13.9718 9.69504 13.6982V13.2369C9.69504 12.9632 9.60124 12.885 9.32762 12.885H8.86633C8.59265 12.885 8.49884 12.9632 8.49884 13.2369V13.6982C8.49884 13.9718 8.59265 14.0578 8.86633 14.0578Z"
                                  fill="black" fill-opacity="0.85" />
                                <path
                                  d="M14.9648 19.4917C17.7092 19.4917 20 17.2009 20 14.4487C20 11.681 17.7326 9.40581 14.9648 9.40581C12.197 9.40581 9.92181 11.6888 9.92181 14.4487C9.92181 17.2244 12.1892 19.4917 14.9648 19.4917Z"
                                  fill="white" />
                                <path
                                  d="M14.9648 18.4206C17.1149 18.4206 18.9366 16.6224 18.9366 14.4487C18.9366 12.2674 17.1384 10.4769 14.9648 10.4769C12.7834 10.4769 10.993 12.2752 10.993 14.4487C10.993 16.638 12.7834 18.4206 14.9648 18.4206Z"
                                  class="fill-success" />
                                <path
                                  d="M14.4878 16.5911C14.3549 16.5911 14.1985 16.5363 14.0969 16.4269L12.7756 14.9726C12.6818 14.871 12.6427 14.7302 12.6427 14.6208C12.6427 14.3393 12.8616 14.1282 13.1352 14.1282C13.2994 14.1282 13.4245 14.2064 13.5027 14.2924L14.4644 15.3323L16.3722 12.6895C16.466 12.5644 16.6067 12.4706 16.7866 12.4706C17.0446 12.4706 17.2791 12.6817 17.2791 12.9554C17.2791 13.0414 17.24 13.1508 17.1697 13.2525L14.9022 16.4034C14.8162 16.5207 14.6599 16.5911 14.4878 16.5911Z"
                                  fill="white" />
                              </svg>
                            </div>
                            <p class="mb-0 d-inline-block align-middle body-2-1">{{ $formatDate(product_cart.service_date) }}</p>
                          </div>
                          <div class="w-100 no-ws mb-1">
                            <div class="d-inline-block align-middle mr-2">
                              <svg class="lh-1" width="20" height="19" viewBox="0 0 20 19" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_499_24)">
                                  <path
                                    d="M3.89193 9.98433H7.97963C8.28501 9.98433 8.52778 9.74938 8.52778 9.43618V4.15818C8.52778 3.85278 8.28501 3.61785 7.97963 3.61785C7.67425 3.61785 7.4393 3.85278 7.4393 4.15818V8.89585H3.89193C3.5787 8.89585 3.34378 9.1308 3.34378 9.43618C3.34378 9.74938 3.5787 9.98433 3.89193 9.98433ZM7.98745 17.1261C12.3571 17.1261 15.9749 13.5004 15.9749 9.13862C15.9749 4.76899 12.3493 1.15114 7.97963 1.15114C3.61785 1.15114 0 4.76899 0 9.13862C0 13.5004 3.62568 17.1261 7.98745 17.1261ZM7.98745 15.7948C4.29131 15.7948 1.33908 12.8347 1.33908 9.13862C1.33908 5.44244 4.28348 2.48238 7.97963 2.48238C11.6758 2.48238 14.6437 5.44244 14.6437 9.13862C14.6437 12.8347 11.6836 15.7948 7.98745 15.7948Z"
                                    fill="black" fill-opacity="0.85" />
                                  <path
                                    d="M14.9491 18.285C17.7055 18.285 20 15.9906 20 13.2341C20 10.462 17.7212 8.18324 14.9491 8.18324C12.1848 8.18324 9.90601 10.462 9.90601 13.2341C9.90601 16.0141 12.177 18.285 14.9491 18.285Z"
                                    fill="white" />
                                  <path
                                    d="M14.9491 17.2122C17.1104 17.2122 18.9271 15.4111 18.9271 13.2341C18.9271 11.0494 17.1339 9.25609 14.9491 9.25609C12.7721 9.25609 10.971 11.0572 10.971 13.2341C10.971 15.4267 12.7721 17.2122 14.9491 17.2122Z"
                                    class="fill-success" />
                                  <path
                                    d="M14.4714 15.3798C14.3462 15.3798 14.1817 15.325 14.0799 15.2153L12.7564 13.7588C12.6625 13.657 12.6311 13.5161 12.6311 13.4064C12.6311 13.1245 12.8426 12.9131 13.1167 12.9131C13.2811 12.9131 13.4064 12.9914 13.4926 13.0775L14.4557 14.119L16.3665 11.4722C16.4526 11.3391 16.6014 11.2529 16.7737 11.2529C17.0399 11.2529 17.267 11.4643 17.267 11.7384C17.267 11.8246 17.2357 11.9342 17.1574 12.036L14.8864 15.1919C14.8003 15.3093 14.6437 15.3798 14.4714 15.3798Z"
                                    fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_499_24">
                                    <rect width="20" height="18.285" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <p class="mb-0 d-inline-block align-middle body-2-1">{{ $customFormatDateTime(product_cart.service_time.schedule_start, "HH:mm:ss", "hh:mm A") }}</p>
                          </div>
                        </div>
                        <div class="col-4 text-right">
                          <p class="text-16 font-lato mb-2 text-semi-dark">{{ $formatCurrency(product_cart.base_price.display.final) }}</p>
                          <div class="w-100 no-ws mb-1 text-right">
                            <div class="d-inline-block align-middle mr-1">
                              <svg class="lh-1" width="17" height="20" viewBox="0 0 17 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_500_31)">
                                  <path
                                    d="M1.75168 16.6171H10.7389C11.9258 16.6171 12.4906 16.2596 12.4906 15.4732C12.4906 13.5999 10.1241 10.8902 6.24888 10.8902C2.36657 10.8902 0 13.5999 0 15.4732C0 16.2596 0.564829 16.6171 1.75168 16.6171ZM1.41565 15.5375C1.22975 15.5375 1.15111 15.4874 1.15111 15.3373C1.15111 14.1576 2.96714 11.9698 6.24888 11.9698C9.52347 11.9698 11.3395 14.1576 11.3395 15.3373C11.3395 15.4874 11.268 15.5375 11.0821 15.5375H1.41565ZM6.24888 9.99643C7.95048 9.99643 9.33757 8.48787 9.33757 6.6432C9.33757 4.81287 7.95768 3.37578 6.24888 3.37578C4.55438 3.37578 3.16019 4.84147 3.16019 6.65754C3.16019 8.49501 4.54723 9.99643 6.24888 9.99643ZM6.24888 8.91684C5.20501 8.91684 4.3113 7.92303 4.3113 6.65754C4.3113 5.41345 5.19071 4.45539 6.24888 4.45539C7.3142 4.45539 8.18647 5.392 8.18647 6.6432C8.18647 7.90869 7.29986 8.91684 6.24888 8.91684Z"
                                    fill="black" fill-opacity="0.85" />
                                  <path
                                    d="M7.95769 15.9236C7.95769 17.7253 8.92288 18.4474 11.1893 19.7773C11.6612 20.0561 12.3119 20.0919 12.841 19.7773C15.1074 18.4474 16.0798 17.7253 16.0798 15.9236V13.3568C16.0798 12.5704 15.7151 11.8983 14.9001 11.598L12.6979 10.7829C12.2546 10.6184 11.7328 10.6399 11.2537 10.8187L9.1302 11.598C8.32229 11.8911 7.95769 12.5704 7.95769 13.3568V15.9236Z"
                                    fill="white" />
                                  <path
                                    d="M8.93715 16.038C8.93715 17.4108 9.73792 17.9112 11.6826 19.048C11.8543 19.1552 12.126 19.1767 12.3476 19.048C14.2923 17.904 15.1002 17.4108 15.1002 16.038V13.4641C15.1002 13.0494 14.943 12.7777 14.5211 12.5989C14.0993 12.4274 12.7766 11.9554 12.369 11.8125C12.1331 11.7339 11.8686 11.7339 11.604 11.841C11.2537 11.9698 9.93096 12.4274 9.51633 12.5989C9.09444 12.7777 8.93715 13.0494 8.93715 13.4641V16.038Z"
                                    class="fill-success" />
                                  <path
                                    d="M11.5826 17.332C11.4682 17.332 11.318 17.282 11.2323 17.1748L10.0168 15.8521C9.93816 15.7591 9.9024 15.6304 9.9024 15.5232C9.9024 15.2729 10.0954 15.0727 10.3457 15.0727C10.4958 15.0727 10.6102 15.1442 10.6888 15.23L11.5683 16.1809L13.3128 13.7572C13.3914 13.6428 13.5273 13.5642 13.6917 13.5642C13.9277 13.5642 14.1422 13.7501 14.1422 14.0074C14.1422 14.0861 14.1064 14.1862 14.0421 14.272L11.9615 17.1605C11.8829 17.2606 11.7399 17.332 11.5826 17.332Z"
                                    fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_500_31">
                                    <rect width="16.0798" height="20" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <p class="mb-0 d-inline-block align-middle body-2-1">{{ product_cart.qty }} Person</p>
                          </div>
                          <div class="d-table ml-auto cursor-pointer">
                            <svg class="cursor-pointer" @click="removeProductCart(product_cart.original_data)" width="13" height="16" viewBox="0 0 13 16" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_201_6878)">
                                <path
                                  d="M4.41081 12.7934C4.15135 12.7934 3.98503 12.6403 3.97172 12.3875L3.77214 5.06279C3.76549 4.81663 3.93181 4.65696 4.19792 4.65696C4.44407 4.65696 4.61705 4.80998 4.6237 5.05613L4.83659 12.3875C4.84324 12.6337 4.67027 12.7934 4.41081 12.7934ZM6.43994 12.7934C6.18045 12.7934 6.00082 12.6337 6.00082 12.3875V5.06279C6.00082 4.81663 6.18045 4.65696 6.43994 4.65696C6.69939 4.65696 6.88565 4.81663 6.88565 5.06279V12.3875C6.88565 12.6337 6.69939 12.7934 6.43994 12.7934ZM8.47568 12.7934C8.21624 12.7934 8.04326 12.6337 8.0499 12.3875L8.25615 5.06279C8.26279 4.80998 8.43577 4.65696 8.68193 4.65696C8.94801 4.65696 9.11435 4.81663 9.10771 5.06279L8.9081 12.3875C8.89482 12.6403 8.72848 12.7934 8.47568 12.7934ZM3.51934 3.04033H4.57713V1.61663C4.57713 1.23742 4.84324 0.991266 5.24241 0.991266H7.62412C8.02328 0.991266 8.28942 1.23742 8.28942 1.61663V3.04033H9.34717V1.5501C9.34717 0.585447 8.72184 0 7.6973 0H5.16923C4.1447 0 3.51934 0.585447 3.51934 1.5501V3.04033ZM0.49896 3.57256H12.3875C12.6603 3.57256 12.8798 3.33971 12.8798 3.06694C12.8798 2.79418 12.6603 2.56798 12.3875 2.56798H0.49896C0.232848 2.56798 0 2.79418 0 3.06694C0 3.34636 0.232848 3.57256 0.49896 3.57256ZM3.39293 14.8158H9.49358C10.4449 14.8158 11.0836 14.1971 11.1302 13.2457L11.5959 3.43285H1.28399L1.75634 13.2524C1.80291 14.2037 2.42827 14.8158 3.39293 14.8158Z"
                                  fill="#DC3545" />
                              </g>
                              <defs>
                                <clipPath id="clip0_201_6878">
                                  <rect width="12.8798" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-100 p-4">
                      <div class="row">
                        <div class="col-4">
                          <p class="mb-0 heading-6-1">Total</p>
                        </div>
                        <div class="col-8 text-right">
                          <p class="text-20 font-lato mb-0">{{ $formatCurrency(getActivityTrxDisplayTotal) }}</p>
                        </div>
                        <div class="col-12 mt-4" v-if="getActivityTrxProducts.length > 0">
                          <button class="g-btn g-btn-primary-outline g-btn-lg w-100" @click="goToPageCart()">Proceed Booking</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- MOBILE -->
              <div class="w-100 fixed-bottom py-4 bg-white" v-if="window_width < 992 && getActivityTrxProducts.length > 0">
                <div class="ga-container">
                  <CartTimer font_size="body-3-1" v-if="window_width < 992 && $isNotEmpty(getActivityTrxExpiredAt)" />
                  <div class="w-100 bg-green radius-12 px-4 py-3">
                    <div class="row align-items-center">
                      <div class="col-sm-8 col-6">
                        <p class="mb-0 font-lato text-white" :class="window_width >= 576 ? 'text-18' : 'text-16'">{{$formatCurrency(getActivityTrxDisplayTotal)}}</p>
                        <div class="w-100 no-ws">
                          <p class="mb-0 text-light d-inline-block align-middle" :class="window_width >= 576 ? 'body-2-4' : 'body-3-3-2'">{{ getActivityTrxProducts.length }} Ticket(s)</p>
                          <!-- <p class="mb-0 font-bold text-18 mx-3 d-inline-block align-middle text-white">|</p>
                          <p class="mb-0 body-2-4 text-light d-inline-block align-middle">Detail</p> -->
                        </div>
                      </div>
                      <div class="col-sm-4 col-6">
                        <button @click="goToPageCart()" type="button" class="button-primary text-right text-14 w-100">Book Now<img src="../../../../assets/img/icon/back-white.png" class="ml-1 position-relative transform-180" style="top: -1px;" width="18"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </b-skeleton-wrapper>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex'
  import {
    get
  } from '@/services/index.js'
  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
  import Navbar from '@/components/hotel/concierge/general/Navbar';
  import HomeSlider from '@/components/general/HomeSlider';
  import Product from '@/components/hotel/concierge/activity/Product'
  import Footer from '@/components/hotel/concierge/general/Footer';
  import CartTimer from '@/components/hotel/concierge/pos/CartTimer';

  export default {
    components: {
      Navbar,
      CoolLightBox,
      Product,
      Footer,
      HomeSlider,
      CartTimer
    },
    metaInfo() {
      return {
        title: this.page_title,
        titleTemplate: this.getMetaTitleTemplate
      }
    },
    data() {
      return {
        active_image: null,
        is_load: true,
        error: '',
        general_data: {},
        category: {
          selected: {},
          list: []
        },
        product_list: [],
        window_width: window.innerWidth
      }
    },
    computed: {
      ...mapGetters([
        'getMerchant', 
        'getMetaTitleTemplate', 
        'getActivityTrxProducts',
        'getActivityTrxDisplayTotal',
        'getActivityTrxPromoCode',
        'getActivityTrxExpiredAt',
        'getActivityTrxPageModule'
      ]),
      product_display(){
        let return_data = this.product_list 
        if(this.category.selected.id && this.category.selected.id != 'all'){
          return_data = this.product_list.filter(x=>x.category.id == this.category.selected.id)
        } 
        return return_data
      },
      page_module(){
        if(this.$route.meta.sub_module) return this.$route.meta.sub_module
        return ''
      },
      api_module(){
        if(this.page_module == 'hotel-activity') return 'CORE_HOTEL'
        return 'CONCIERGE'
      },
      pos_code() {
        if(this.page_module == 'hotel-activity') return this.$route.params.pos_code
        return 'spa'
      },
      page_title(){
        if(this.general_data.id) return this.$isNotEmpty(this.general_data.tagline) ? this.general_data.tagline : this.general_data.name
        return ''
      }
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
      this.loadFirstData()
    },
    beforeDestroy() { 
      clearInterval(this.expired_time_interval)
    },
    methods: {
      ...mapMutations(['removeTrxActivityProduct','clearTrxActivityProduct']),
      onResizeWindow(){
        this.window_width = window.innerWidth
      },
      goToPageCart() {
        let params = { merchant_code: this.getMerchant.code }
        if(this.page_module == 'hotel-activity') params.pos_code = this.pos_code
        let page = this.page_module == 'concierge-spa' ? 'ConciergeSpaCart' : 'HotelActivityCart'

        this.$router.push({
          name: page,
          params: params
        })
      },
      loadFirstData() {
        this.is_load = true
        this.error = ''
        this.loadGeneralData().then(()=>{
          Promise.all([
            this.loadCategoryList(),
            this.loadProductList()
          ])
          .then(()=>{
            let pos_id = this.page_module == 'concierge-spa' ? this.general_data.merchant_pos_id : this.general_data.id
            if(!(this.getActivityTrxPageModule == '' || this.getActivityTrxPageModule == pos_id)){
              this.clearTrxActivityProduct()
            }
            this.validateCategory()
          })
          .catch(err => this.error = err)
          .finally(() => this.is_load = false)
        }).catch(err => {
          this.error = err
          this.is_load = false
        })
      },
      generateApiUrl(api){
        let is_spa_page = this.page_module == 'concierge-spa'
        
        if(api == 'general'){
          return is_spa_page ? 'spa/general' : `merchant-pos/${this.pos_code}/general`
        }else if(api == 'category'){
          return is_spa_page ? 'spa/category-option' : `merchant-pos/${this.general_data.id}/product-category-option`
        }

        return is_spa_page ? 'spa/product' : `merchant-pos/${this.general_data.id}/product`
      },
      loadGeneralData() {
        return new Promise((success, fail) => {
          this.general_data = {}
          get(this.api_module, this.generateApiUrl('general'), {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.general_data = res.data
              this.$validatePage('CONCIERGE',this.general_data).then(()=>{
                if(this.page_module == 'hotel-activity'){
                  this.general_data.slider_list = this.general_data.slider_image
                }
                success()
              }).catch(()=>fail())
            } else {
              fail(res.message)
            }
          })
        })
      },
      loadCategoryList() {
        return new Promise((success, fail) => {
          this.category = {
            list: [],
            selected: {}
          }
          get(this.api_module, this.generateApiUrl('category'), {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.category.list = res.data
              this.category.list.unshift({
                id: 'all',
                name: this.$t('general.all-categories')
              })
              this.category.selected = this.category.list[0]
              success()
            } else {
              fail(res.message)
            }
          })
        })
      },
      loadProductList() {
        return new Promise((success, fail) => {
          this.product_list = []
          get(this.api_module, this.generateApiUrl('product'), {
            merchant_id: this.getMerchant.id,
            page_size: 1000,
            promo_code: this.getActivityTrxPromoCode
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.product_list = res.data
              success()
            } else {
              fail(res.message)
            }
          })
        })
      },
      validateCategory(){
        this.category.list = this.category.list.map(cate=>{
          let is_has_product = this.product_list.some(x=>x.category.id == cate.id)
          cate.show = is_has_product
          return cate
        })
        this.category.list[0].show = true
      },
      selectCategory(category){
        this.category.selected = category
      },
      removeProductCart(product){
        this.removeTrxActivityProduct({
          product: product
        })
      }
    }
  }

</script>
<style>
  .card-product-height {
    height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/activity/index.vue